import { useRouter } from 'next/router';
import React, { useState } from 'react';

import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import CreateDiscussionDialog from '../createDiscussionDialog';

import CourseDiscussionSearchBox from './courseDiscussionSearchBox';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import { useCourseDiscussionList } from '@hooks/course/courseDiscussion/useCourseDiscussionList';

type HandleFetchCourseDiscussionListProps = {
  page: number;
  title?: string;
};

type CourseDiscussionBoardHeaderProps = {
  isInitialFetch: boolean;
  setSearchQuery: (searchQuery: string) => void;
  searchQuery: string;
  handleFetchCourseDiscussionList: ({ page, title }: HandleFetchCourseDiscussionListProps) => void;
};

const CourseDiscussionBoardHeader = ({
  isInitialFetch,
  setSearchQuery,
  searchQuery,
  handleFetchCourseDiscussionList,
}: CourseDiscussionBoardHeaderProps) => {
  const { t } = useTranslation('store_course');

  const [isOpenCreateDiscussionDialog, setIsOpenCreateDiscussionDialog] = useState<boolean>(false);
  const handleOpenCreateDiscussionDialog = () => {
    setIsOpenCreateDiscussionDialog(true);
  };
  const router = useRouter();
  const idName = router.query.idName as string;
  const { courseDiscussionListData } = useCourseDiscussionList({ idName });

  const hasData = courseDiscussionListData?.items.length > 0;

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4">{t('course_detail.course_discussion.title')}</Typography>
        {(hasData || searchQuery || !isInitialFetch) && (
          <Button variant="contained" onClick={handleOpenCreateDiscussionDialog}>
            <FontAwesomeIcon color="#fff" icon="fa-light fa-plus-large" />
            <Typography variant="button_deprecated" color="#fff" ml={1}>
              {t('course_detail.course_discussion.create_discussion')}
            </Typography>
          </Button>
        )}
      </Box>
      <CourseDiscussionSearchBox
        isInitialFetch={isInitialFetch}
        setSearchQuery={setSearchQuery}
        searchQuery={searchQuery}
        hasData={hasData}
      />
      <CreateDiscussionDialog
        isOpen={isOpenCreateDiscussionDialog}
        setIsOpen={setIsOpenCreateDiscussionDialog}
        handleFetchCourseDiscussionList={handleFetchCourseDiscussionList}
      />
    </>
  );
};

export default CourseDiscussionBoardHeader;
